import _ from 'lodash'
import { config } from '../../components/Init/Init'

const getGameIconTout = (img0, img768) => {
  return [
    {
      slot: {
        0: {
          area: 'fill',
          classes: '',
          content: {
            type: 'image',
            url: `/content/images/{gameId}${img0.suffix}${img0.extension}`,
            flashPrizeUrl: `/content/images/games-flash-prize/{gameId}${img0.suffix}${img0.extension}`,
            diamondDashUrl: `/content/images/games-diamond-dash/{gameId}${img0.suffix}${img0.extension}`,
            jackpotUrl: `/content/images/games-jackpot/{gameId}${img0.suffix}${img0.extension}`,
            flashDiamondUrl: `/content/images/games-flash-diamonds/{gameId}${img0.suffix}${img0.extension}`,
            hasWebp: img0.hasWebp,
            template: img0.template
          }
        },
        768: {
          area: 'fill',
          classes: '',
          content: {
            type: 'image',
            url: `/content/images/{gameId}${img768.suffix}${img768.extension}`,
            flashPrizeUrl: `/content/images/games-flash-prize/{gameId}${img768.suffix}${img768.extension}`,
            diamondDashUrl: `/content/images/games-diamond-dash/{gameId}${img768.suffix}${img768.extension}`,
            jackpotUrl: `/content/images/games-jackpot/{gameId}${img768.suffix}${img768.extension}`,
            flashDiamondUrl: `/content/images/games-flash-diamonds/{gameId}${img768.suffix}${img768.extension}`,
            hasWebp: img768.hasWebp,
            template: img768.template
          }
        }
      },
      asset: {
        title: '{title}',
        id: '{id}',
        provider: '{provider}'
      }
    }
  ]
}

export default function getTout(template = config.gameIconTemplate, tileSpan = 1) {
  let firstSuffix = '-200x200'
  let secondSuffix = ''
  let isSvg = false
  let isDropsAndWins = false
  if (tileSpan === 2) {
    firstSuffix = '-159x420'
    secondSuffix = '-hero-1x2'
  } else if (tileSpan === 4) {
    firstSuffix = '-159x420'
    secondSuffix = '-hero-2x2'
  }

  switch (template) {
    case config.gameIconTemplate:
      isSvg = false
      isDropsAndWins = false
      break
    case config.gameIconSvgTemplate:
      isSvg = true
      isDropsAndWins = false
      break
    case config.gameIconDropsAndWinsTemplate:
      isSvg = false
      isDropsAndWins = true
      break
    case config.gameIconDropsAndWinsSvgTemplate:
      isSvg = true
      isDropsAndWins = true
      break
    default:
      break
  }

  if (isDropsAndWins) {
    firstSuffix += '-dw'
    secondSuffix += '-dw'
  }

  return _.cloneDeep(
    getGameIconTout(
      { suffix: firstSuffix, extension: isSvg ? '.svg' : '.jpg 2x', hasWebp: !isSvg, template: template },
      { suffix: secondSuffix, extension: isSvg ? '.svg' : '.jpg', hasWebp: !isSvg, template: template }
    )
  )
}
